import styled from "styled-components";

export const Wrapper = styled.div`
    margin-top: 10px;
`
export const ProductContent = styled.div`
    display: flex;
    flex-direction: column;
    background: #f4f6f9;
    padding: 18px;
    border-radius: 12px;
    margin-bottom: 14px;
    @media only screen and (min-width: 280px) and (max-width: 767px) {
        flex-direction: column;
    }
`
export const FirstDiv = styled.div`
    min-height: 50px;
    padding-top: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    @media only screen and (min-width: 280px) and (max-width: 767px) {
        width: 100%;
    }
`;

export const SecondDiv = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 12px;
    width: 100%;

    @media (min-width: 768px) {
        justify-content: space-between;
    }
`;

export const FlexItemsContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    gap: 14px;
    @media (max-width: 768px) {
        flex-direction: column;
    }
`;

export const FlexItem = styled.div`
    margin-right: 10px;
`;

export const Amount = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 6px;
    font-weight: var(--general-amount-font-weight);
    white-space: nowrap;
    font-size: var(--general-amount-font-size);
    @media (min-width: 767px) {
        margin-left: auto;
    }
`
export const Title = styled.span`
    margin-bottom: 8px;
    display: block;
    font-weight: var(--general-sub-header-font-weight);
    font-size: var(--general-sub-header-font-size);
    text-transform: capitalize;
`
export const AmountField = styled.div`
    position: relative;
    label {
        margin: 0;
    }
    input {
        font-size: var(--general-xlarge-body-font-size) !important;
    }
`;
export const AmountSign = styled.span`
    position: absolute;
    left: 5px;
    top: 50%;
    transform: translateY(-50%);
    font-size: var(--general-amount-font-size);
`;
export const SelectWrapper = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    flex-direction: column-reverse;
    justify-content: space-between;
    gap: 10px;

    @media (min-width: 767px) {
        flex-direction: row-reverse;
    }
`;
export const VarientAmount = styled.div`
    min-width: 65px;
    font-size: var(--general-amount-font-size);
    @media (min-width: 1200px) {
        margin-right: 39px;
    }
`
